import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { copyColor, copyFontFamily, copyFontSize, copyLineHeight, copyFontSizeSmall, copyFontSizeLarge, token, copyFontWeight } from '@nib-components/theme';
import { color as getColor, validFgColorValues, map, breakpoint } from '@nib/layout';
export const validSizeValues = ['small', 'medium', 'large'];
const BaseCopy = props => {
  /* eslint-disable @typescript-eslint/no-unused-vars */const {
    component: Component = 'p',
    measure,
    small,
    large,
    size,
    align,
    color,
    weight,
    transform,
    theme,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(Component, {
    "data-mesh-component": "COPY",
    ...otherProps
  });
};
const isNamedColor = color => {
  if (!color) return false;
  if (validFgColorValues.includes(color)) {
    return true;
  }
  return false;
};
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const setColor = props => {
  if (isNamedColor(props.color)) {
    return getColor();
  }
  if (props.color !== 'inherit') {
    return css`
      color: ${props.color || `var(--themeColorFg, ${copyColor})`};
    `;
  }
  return 'color: inherit';
};
const Copy = styled(BaseCopy).attrs(props => ({
  measure: true,
  align: 'start',
  color: 'inherit',
  small: false,
  large: false,
  ...props
}))`
  margin: 0;

  /* // eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  ${props => setColor({
  ...props,
  color: props.color
})};
  font-family: ${token('theme.typography.copy.fontFamily', copyFontFamily)};
  font-size: ${token('theme.typography.copy.fontSize', copyFontSize)};
  font-weight: ${token('theme.typography.copy.fontWeight', copyFontWeight)};
  line-height: ${token('theme.typography.copy.lineHeight', copyLineHeight)};
  letter-spacing: ${token('theme.typography.copy.letterSpacing')};
  text-wrap: pretty;
  word-break: break-word;
  hyphens: auto;

  ${breakpoint('mini')`
    hyphens: none;  
  `}

  ${props => props.transform && css`
      text-transform: ${props.transform};
    `}

  ${props => props.measure && css`
      max-width: 32em;
    `}

  ${_ref => {
  let {
    align,
    measure
  } = _ref;
  return map(align, val => {
    if (measure) {
      if (val === 'left' || val === 'start') return css`
            text-align: start;
            margin-inline: 0 auto;
          `;
      if (val === 'center') return css`
            text-align: ${val};
            margin-inline: auto;
          `;
      if (val === 'right' || val === 'end') return css`
            text-align: end;
            margin-inline: auto 0;
          `;
    } else if (align) {
      if (val === 'left' || val === 'start') return css`
            text-align: start;
          `;
      if (val === 'center') return css`
            text-align: ${val};
          `;
      if (val === 'right' || val === 'end') return css`
            text-align: end;
          `;
    }
    return '';
  });
}}

  ${props => props.small && css`
      font-family: ${token('theme.typography.copy.small.fontFamily', copyFontFamily)};
      font-size: ${token('theme.typography.copy.small.fontSize', copyFontSizeSmall)};
      font-weight: ${token('theme.typography.copy.small.fontWeight', copyFontWeight)};
      line-height: ${token('theme.typography.copy.small.lineHeight', copyLineHeight)};
      letter-spacing: ${token('theme.typography.copy.small.letterSpacing')};
    `}

  ${props => props.large && css`
      font-family: ${token('theme.typography.copy.large.fontFamily', copyFontFamily)};
      font-size: ${token('theme.typography.copy.large.fontSize', copyFontSizeLarge)};
      font-weight: ${token('theme.typography.copy.large.fontWeight', copyFontWeight)};
      line-height: ${token('theme.typography.copy.large.lineHeight', copyLineHeight)};
      letter-spacing: ${token('theme.typography.copy.large.letterSpacing')};
    `}
  
  ${props => props.size && !props.small && !props.large && map(props.size, val => {
  if (val === 'small') {
    return css`
          font-size: ${token('theme.typography.copy.small.fontSize', copyFontSizeSmall)};
        `;
  } else if (val === 'large') {
    return css`
          font-size: ${token('theme.typography.copy.large.fontSize', copyFontSizeLarge)};
        `;
  } else {
    return css`
          font-size: ${token('theme.typography.copy.fontSize', copyFontSize)};
        `;
  }
})}
`;
Copy.displayName = 'Copy';
export default Copy;
export const Italic = styled(Copy).attrs({
  component: 'em',
  'data-mesh-component': 'ITALIC'
})`
  font-style: italic;

  ${Copy} > & {
    font-size: inherit;
  }
`;
Italic.displayName = 'Italic';
export const Bold = styled(Copy).attrs(props => ({
  component: 'strong',
  'data-mesh-component': 'BOLD',
  ...props
}))`
  font-weight: ${props => props.weight ? props.weight : token('theme.typography.copy.bold.fontWeight', 'bold')};

  ${Copy} > & {
    font-size: inherit;
  }
`;
Bold.displayName = 'Bold';